import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const BouncyCardsFeatures = () => {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 text-slate-800">
      <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end md:px-8">
        <h2 className="max-w-lg text-4xl font-bold md:text-5xl">
          Solutions tailored   
          <span className="text-slate-400"> for the real world</span>
        </h2>
        <Link to={"/inserr"}>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="whitespace-nowrap rounded-lg bg-green-900 px-4 py-2 font-medium text-white shadow-xl transition-colors hover:bg-green-700"
        >
          Learn more
        </motion.button></Link>
      </div>
      <div className="mb-4 grid grid-cols-12 gap-4">
        <BounceCard className="col-span-12 md:col-span-4">
          <CardTitle>Coastguards Duties</CardTitle>
          <span class="block  font-semibold p-5 text-lg">
          Advanced ROV solutions for diver-free operations, ensuring safety and efficiency in even the most challenging conditions.
          </span>
          <div className="absolute bottom-0 left-4 right-4 top-10  rounded-t-2xl p-4 translate-y-4  transition-transform duration-[250ms] group-hover:translate-y-40 group-hover:rotate-[2deg]">
            <span className="block text-center font-semibold text-indigo-50">
            <img class="rounded-t-lg object-cover" src={require("../../../../assets/img/stock/coastguard.jpg")} style={{height:"15em",width:"25em"}} alt="coast" /> 
            </span>
          </div>
        </BounceCard>
        <BounceCard className="col-span-12 md:col-span-4">
          <CardTitle>Flood Rescues</CardTitle>
          <span class="block  font-semibold p-5 text-lg">
          Cutting-edge ROV technology offering reliable tools for swift and effective flood rescues, even in low-visibility environments.
          </span>
          <div className="absolute bottom-0 left-4 right-4 top-10 rounded-t-2xl  p-4 translate-y-4 transition-transform duration-[250ms] group-hover:translate-y-40 group-hover:rotate-[2deg]">
            
            <span className="block text-center font-semibold text-indigo-50">
              <img class="rounded-t-lg object-cover" src={require("../../../../assets/img/stock/flood.jpg")} style={{height:"15em",width:"25em"}} alt="coast" />
            </span>
          </div>
        </BounceCard>
        <BounceCard className="col-span-12 md:col-span-4">
          <CardTitle>University Learning</CardTitle>
          <span class="block  font-semibold p-5 text-lg">
          Modular, customizable ROV solutions enabling universities with hands-on learning tools for underwater robotics.
            </span>
          <div className="absolute bottom-0 left-4 right-4 top-10 rounded-t-2xl  p-4 translate-y-4 transition-transform duration-[250ms] group-hover:translate-y-40 group-hover:rotate-[2deg]">
            <span className="block text-center font-semibold text-indigo-50">
            <img class="rounded-t-lg object-cover" src={require("../../../../assets/img/stock/macrobo.jpg")} style={{height:"15em",width:"25em"}} alt="coast" />
            </span>
          </div>
        </BounceCard>

      </div>
    </section>
  );
};

const BounceCard = ({ className, children }) => {
  return (
    <motion.div
      whileHover={{ scale: 0.95, rotate: "-1deg" }}
      className={`group relative min-h-[300px] cursor-pointer overflow-hidden rounded-2xl bg-slate-100 p-8 ${className}`}
    >
      {children}
    </motion.div>
  );
};

const CardTitle = ({ children }) => {
  return (
    <h3 className="mx-auto text-center text-3xl font-semibold">{children}</h3>
  );
};